import chatBotIcon from '/src/assets/ChatBotIcon.svg';
import chatBotIconSelected from '/src/assets/ChatBotIconSelected.svg';

export default function navChatbotIconChatbot({isSelected}){
    return <>
        {isSelected ?
            <div className='bot-utn-app-navigation-chatbot-icon'>
                <img
                    className='bot-utn-chatbot-nav-bar-icons'
                    src={chatBotIconSelected}
                    alt="ChatBot Image"
                />
            </div>
            :
            <div className='bot-utn-app-navigation-chatbot-icon'>
                <img
                    className='bot-utn-chatbot-nav-bar-icons'
                    src={chatBotIcon}
                    alt="Recommender Image"
                />
            </div>
        }
    </>
}